"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TabListWrapper = exports.TabListItem = exports.TabListBar = exports.TabContentWrapper = exports.TabContentItem = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Wrapper = _styledComponents.default.div.withConfig({
  componentId: "sc-1nzpeho-0"
})([""]);

exports.Wrapper = Wrapper;

var TabListWrapper = _styledComponents.default.ul.withConfig({
  componentId: "sc-1nzpeho-1"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    position: relative;\n    display: flex;\n    border-bottom: ".concat(_tokens.borderWidth.xs, "px solid ").concat(_tokens.colors[theme.colors.neutral200.color + theme.colors.neutral200.scale], ";\n  ");
});

exports.TabListWrapper = TabListWrapper;

var TabListItem = _styledComponents.default.li.withConfig({
  componentId: "sc-1nzpeho-2"
})(["position:relative;cursor:pointer;overflow:hidden;", ""], function (_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme,
      active = _ref2.active;
  return "\n    padding-top:".concat(size.padding.top, "px;\n    padding-right:").concat(size.padding.right, "px;\n    padding-bottom:").concat(size.padding.bottom, "px;\n    padding-left:").concat(size.padding.left, "px;\n\n    font-family: ").concat(theme.fonts.default, ", sans-serif;\n    font-size: ").concat(size.label.fontSize, "px;\n    line-height: ").concat(size.label.lineHeight, "px;\n    letter-spacing: ").concat(size.label.letterSpacing, "px;\n    color: ").concat(_tokens.colors[theme.colors.neutral800.color + theme.colors.neutral800.scale], ";\n\n    border-bottom: ").concat(_tokens.borderWidth.md, "px solid transparent;\n    &:hover {\n      border-bottom: ").concat(_tokens.borderWidth.md, "px solid ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n    }\n\n    ").concat(active && "\n      & {\n        font-weight: ".concat(_tokens.fontWeight.bold, ";\n        color: ").concat(_tokens.colors[theme.colors.neutral950.color + theme.colors.neutral950.scale], ";\n      }\n    "), "\n  ");
});

exports.TabListItem = TabListItem;

var TabContentWrapper = _styledComponents.default.div.withConfig({
  componentId: "sc-1nzpeho-3"
})([""]);

exports.TabContentWrapper = TabContentWrapper;

var TabContentItem = _styledComponents.default.div.withConfig({
  componentId: "sc-1nzpeho-4"
})(["display:none;", ""], function (_ref3) {
  var active = _ref3.active;
  return active && "\n      & {\n        display: block;\n      }\n    ";
});

exports.TabContentItem = TabContentItem;

var TabListBar = _styledComponents.default.div.withConfig({
  componentId: "sc-1nzpeho-5"
})(["position:absolute;bottom:0;left:0;height:2px;", ""], function (_ref4) {
  var width = _ref4.width,
      position = _ref4.position,
      theme = _ref4.theme;
  return "\n    transition: 0.4s all ease;\n    width: ".concat(width, "px;\n    left: ").concat(position, "px;\n    background-color: ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n  ");
});

exports.TabListBar = TabListBar;